/**
 * Workshop Buy it now label — display only.
 * Runs only on japan-workshop-buytool pages (.jwb-marker).
 * Rewrites visible text + keeps CTA size (width/height) so short label does not shrink the button.
 * Takamura uses assets/takamura-buyitnow-label.js separately.
 */
(() => {
  if (window.__jwbBuyLabelInit) return;
  window.__jwbBuyLabelInit = true;

  const LABEL = '予約する';
  const FROM_LABELS = ['今すぐ購入', 'Buy it now', 'Buy now'];

  function isBuyLabelPage() {
    return Boolean(document.querySelector('.jwb-marker'));
  }

  function cssVar(name, fallback) {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }

  function buttonWidth() {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const raw = cssVar('--jwb-btn-w', mobile ? '106px' : '180px');
    // min()/calc() などが来ても、モバイルは案内文横並び用の固定幅を使う
    if (mobile && (!raw || raw.includes('min(') || raw.includes('max(') || raw.includes('%'))) {
      return '106px';
    }
    return raw;
  }

  function applySize(el) {
    if (!(el instanceof HTMLElement)) return;
    const w = buttonWidth();
    const h = cssVar('--jwb-cta-h', '48px');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('min-width', '100%', 'important');
    el.style.setProperty('max-width', '100%', 'important');
    el.style.setProperty('height', h, 'important');
    el.style.setProperty('min-height', h, 'important');
    if (el.tagName === 'BUTTON') {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('justify-content', 'center', 'important');
      el.style.setProperty('font-size', '16px', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('line-height', '1.2', 'important');
      el.style.setProperty('padding', '0 13px', 'important');
      el.style.setProperty('margin', '0', 'important');
    }
    if (
      el.matches?.(
        '.shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button, .product-form__buttons'
      )
    ) {
      const parentButtons = el.closest?.('.product-form__buttons');
      if (parentButtons instanceof HTMLElement) {
        parentButtons.style.setProperty('width', w, 'important');
        parentButtons.style.setProperty('min-width', w, 'important');
        parentButtons.style.setProperty('max-width', w, 'important');
        parentButtons.style.setProperty('height', h, 'important');
        parentButtons.style.setProperty('min-height', h, 'important');
      }
      const form = el.closest?.('product-form') || parentButtons?.closest?.('product-form');
      if (form instanceof HTMLElement) {
        form.style.setProperty('width', w, 'important');
        form.style.setProperty('min-width', w, 'important');
        form.style.setProperty('max-width', w, 'important');
        form.style.setProperty('flex', '0 0 ' + w, 'important');
      }
    }
  }

  function rewriteButton(btn) {
    if (!(btn instanceof HTMLElement)) return;
    applySize(btn);
    const text = (btn.textContent || '').trim();
    if (text === LABEL) {
      if (btn.getAttribute('aria-label') !== LABEL) btn.setAttribute('aria-label', LABEL);
      return;
    }
    const hit = FROM_LABELS.some((f) => text === f || text.includes(f));
    if (!hit) return;
    btn.textContent = LABEL;
    btn.setAttribute('aria-label', LABEL);
  }

  function walkShadow(root) {
    if (!root) return;
    root.querySelectorAll('button').forEach(rewriteButton);
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) {
        walkShadow(el.shadowRoot);
        observeShadow(el.shadowRoot);
      }
    });
  }

  function observeShadow(root) {
    if (!root || root.__jwbBuyLabelObs) return;
    const obs = new MutationObserver(() => {
      walkShadow(root);
    });
    obs.observe(root, { childList: true, subtree: true, characterData: true });
    root.__jwbBuyLabelObs = obs;
  }

  function applyHost(host) {
    if (!(host instanceof HTMLElement)) return;
    if (!host.closest('.product__info-container')) return;
    applySize(host);
    if (host.shadowRoot) {
      walkShadow(host.shadowRoot);
      observeShadow(host.shadowRoot);
    }
    host.querySelectorAll?.('button').forEach(rewriteButton);
  }

  function apply() {
    if (!isBuyLabelPage()) return;
    document
      .querySelectorAll(
        '.product__info-container .product-form__buttons, .product__info-container .shopify-payment-button, .product__info-container shopify-accelerated-checkout, .product__info-container shopify-buy-it-now-button'
      )
      .forEach(applySize);
    document
      .querySelectorAll(
        '.product__info-container shopify-accelerated-checkout, .product__info-container shopify-buy-it-now-button'
      )
      .forEach(applyHost);
    document
      .querySelectorAll(
        '.product__info-container button.shopify-payment-button__button, .product__info-container button.bss-po-btn-buyitnow'
      )
      .forEach(rewriteButton);
  }

  function init() {
    if (!isBuyLabelPage()) return;
    apply();
    if (document.body && !document.body.__jwbBuyLabelObs) {
      const obs = new MutationObserver(() => apply());
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
      document.body.__jwbBuyLabelObs = obs;
    }
    let n = 0;
    const timer = setInterval(() => {
      apply();
      n += 1;
      if (n >= 100) clearInterval(timer);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('product-info:loaded', () => apply());
})();
